import { Button, Card, Col, Modal, Dropdown } from "react-bootstrap";
import _ from "lodash"
import PerfectScrollbar from 'react-perfect-scrollbar';
import useSearch from './../../hooks/index';
import Searchfield from "../Common/Searchfield";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useQuery } from "react-query";
import { cloneEquipmentById, fetchEquipmentListByProfileId } from "../../../api/index";
import { checkForAPISuccess, showErrorToast, showSuccessToast } from "../../../Common/commonFunctions";
import { ClipLoader } from "react-spinners";
import { ADD_CLONED_EQUIPMENT, SET_ALL_EQUIPMENTS_AND_PROFILE_ACCESSIBILITY } from "../../../store/actions";
import { Icon } from '@iconify/react';
import ToolTip from "../Common/Tooltip";
import { RESPONSE_EXISTING_EQUIPMENT_NAME_CODE } from "../../../Common/constants";
import ApplyOrViewCategoryToMultipleUnits from "../Admin/EquipmentUnitCategory/ApplyOrViewCategoryToMultipleUnits";
import CustomToggle from "../Common/CustomToggle";
import { useQueryConfiguration } from "../../../Common/constants";

const EquipmentList = props => {

    const dispatch = useDispatch();
    const searchHook = useSearch();
    const [utils, setUtils] = useState({
        showSearchBar: false, allEquipments: {},
        loading: true, showEquipmentClonePopup: false,
        selectedEquipment: { id: "", name: "" },
        clonedEquipmentName: '', showApplyCategoryPopup: false
    });

    const isLockedProfile = useSelector(state => state.equipment.isLockedProfile);
    const isEditOngoing = useSelector(state => state.equipment.isEditOngoing);
    const isEquipmentLoading = useSelector(state => state.equipment.equipmentLoading);
    const currentEnlargedImageType = useSelector(state => state.equipment.currentEnlargedImageType);
    const allEquipments = useSelector(state => state.equipment.allEquipments);
    const isComponentLoading = useSelector(state => state.equipment.componentLoading);
    const profileId = window.location.pathname.split("/")[3];

    const fetchEquipments = async () => {
        if(!_.isEmpty(profileId)) {
            const response = await fetchEquipmentListByProfileId(profileId);
            if(checkForAPISuccess(response?.data?.statusCode)) {
                const responseData = response?.data;
                if(!_.isEmpty(responseData?.data)) {
                    dispatch({
                        type: SET_ALL_EQUIPMENTS_AND_PROFILE_ACCESSIBILITY,
                        payload: {
                            equipments: responseData?.data?.equipmentList,
                            lockedProfile: responseData?.data?.lockedProfile
                        }
                    });
                    setUtils({ ...utils, allEquipments: responseData.data.equipmentList });
                }
            }
            else {
                showErrorToast("Failed to get equipments");
            }
        }
    }

    const cloneEquipment = async () => {
        const response = await cloneEquipmentById({
            "equipmentId": utils.selectedEquipment.id,
            "equipmentName": utils.clonedEquipmentName,
            "profileId": profileId
        });
        return response?.data;
    }

    const fetchEquipmentsQuery = useQuery('fetch-equipments', fetchEquipments, { ...useQueryConfiguration });

    const cloneEquipmentQuery = useQuery(`clone-equipment-${utils.selectedEquipment.id}`, cloneEquipment, {...useQueryConfiguration});

    useEffect(() => {
        if(cloneEquipmentQuery.isFetched) {
            if(
                checkForAPISuccess(cloneEquipmentQuery?.data?.statusCode) ||
                _.isEqual(cloneEquipmentQuery?.data?.statusCode, RESPONSE_EXISTING_EQUIPMENT_NAME_CODE)
            ) {
                const data = _.cloneDeep(cloneEquipmentQuery?.data);
                if(checkForAPISuccess(data?.statusCode)) {
                    dispatch({
                        type: ADD_CLONED_EQUIPMENT,
                        payload: {
                            index: _.findIndex(_.cloneDeep(allEquipments), (arr) => arr.id === utils.selectedEquipment.id ),
                            equipmentData: {
                                "name": data?.data?.name, "id": data?.data?.id,
                                "location": data?.data?.location, "isCloned": true,
                                "isCategoryNotAppliedEquipment": data?.data?.isCategoryNotAppliedEquipment
                            }
                        }
                    });
                }

                showSuccessToast("Provided equipment name already exists. Provide different name");
            }
            else {
                showErrorToast("Failed to clone equipment");
            }
            cloneEquipmentQuery.remove();
        }
    }, [cloneEquipmentQuery.isFetched]);

    useEffect(() => {
        setUtils({
            ...utils, clonedEquipmentName: "", showEquipmentClonePopup: false,
            allEquipments: !_.isEmpty(allEquipments) ? _.cloneDeep(searchHook.filterList(_.cloneDeep(allEquipments), "name")) : null
        });
    }, [searchHook.searchValue, allEquipments]);

    useEffect(() => {
        fetchEquipmentsQuery.refetch();
    }, []);

    const setCurrentEquipment = (id, name) => {
        id = !_.isEqual(id, utils.selectedEquipment.id) ? id : "";
        name = !_.isEqual(name, utils.selectedEquipment.name) ? name : "";
        setUtils({ ...utils, selectedEquipment: { id: id, name: name } });
        props.setCurrentEquipmentId(id);
    }

    const checkIfEquipmentSelected = (id) => !_.isEmpty(utils.selectedEquipment.id) && utils.selectedEquipment.id === id

    const returnClass = (value) => {
        return "flex-space-even align-items-center h-60-px p-2" +
            (
                checkIfEquipmentSelected(value.id)
                    ? " selected-equipment"
                    : " equipment-style"
            ) +
            ((isEditOngoing || isEquipmentLoading || isComponentLoading) ? " disable-click" : "");
    }

    return (
        _.isEmpty(currentEnlargedImageType) &&
            <Col className="p-1" {...props?.breakPoints}>
                <Card className="p-0" style={{"height": "100%"}}>
                    <Card.Header>
                        <Card.Title style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div className="ml-3 w-75">
                                <h5><b>Equipments</b></h5>
                            </div>
                            <div className="equipmentlist-header-icons">
                                {
                                    !isEditOngoing &&
                                        <>
                                            <ToolTip
                                                toolTipKEy={`search`}
                                                toolTipValue={`Search`}
                                                overlayComponent={
                                                    <Icon
                                                        className={`pointer ${isEditOngoing ? "disable-click" : ""}`} icon={'feather-search'}
                                                        onClick={() => setUtils({ ...utils, showSearchBar: !utils.showSearchBar })}
                                                    />
                                                }
                                            />
                                            <Dropdown drop="left">
                                                <Dropdown.Toggle as={CustomToggle} id="dropdown-basic">
                                                    <Icon className="color-primary" icon={'feather:more-vertical'} />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu alightRight={true}>
                                                    <Dropdown.Item
                                                        className="category-dropdown-option" 
                                                        href={`${window.configs.dashboard_base_path}/equipment-unit-categories/${profileId}`}
                                                    >
                                                        View all categories in this profile
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        onClick={() => setUtils({ ...utils, showApplyCategoryPopup: true })} 
                                                        className="category-dropdown-option"
                                                    >
                                                        Apply category to equipment units
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </>
                                }
                            </div>
                        </Card.Title>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <PerfectScrollbar  style={{ height: window.innerHeight - 190 }}>
                            {
                                utils.showSearchBar && !isEditOngoing &&
                                <Searchfield
                                    inputClear={() => searchHook.clearValue()}
                                    inputChange={(value) => searchHook.setSearchValue(value.target.value)}
                                    inputValue={searchHook.searchValue}
                                    placeholder="Search for Equipment Names"
                                />
                            }
                            {
                                _.isEmpty(utils.allEquipments) ?
                                    <div className="equipment-list-flex-box equipment-scroll-viewport-height px-3">
                                        <center>
                                            {
                                                fetchEquipmentsQuery.isFetching ?
                                                    <ClipLoader color="#075978" />
                                                        :
                                                    <b> NO EQUIPMENTS FOUND </b>
                                            }
                                        </center>
                                    </div>
                                    :
                                <>
                                    {
                                        utils.allEquipments.map((value, key) => 
                                            <div className={returnClass(value)} key={key}>
                                                <div onClick={() => setCurrentEquipment(value.id, value.name)} className="w-100 vertical-center-align">
                                                    <div style={{ width: "20px" }}>
                                                        {
                                                            value.isCategoryNotAppliedEquipment &&
                                                                <ToolTip
                                                                    toolTipKEy={`category-not-applied-${value.id}`}
                                                                    toolTipValue={`Has some category unapplied equipment unit(s)`}
                                                                    overlayComponent={
                                                                        <Icon
                                                                            className={"cursor-pointer mr-1"}
                                                                            width={15} height={15} color={"red"}
                                                                            icon={'feather-alert-circle'}
                                                                        />
                                                                    }
                                                                />
                                                        }
                                                    </div>
                                                    <div className="ml-1">
                                                        <div>
                                                            {value.name}
                                                        </div>
                                                        <div className="text-color-grey">
                                                            {value.location}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mr-3">
                                                    {
                                                        checkIfEquipmentSelected(value.id) && !isLockedProfile &&
                                                        <ToolTip
                                                            toolTipKEy={`equipment-clone-${value.id}`}
                                                            toolTipValue={`Clone ${value.name}`}
                                                            overlayComponent={
                                                                <Icon width={18} height={18} icon={"feather-link-2"} color={isEditOngoing ? "gray" : "#075978"}
                                                                    onClick={() => setUtils({ ...utils, clonedEquipmentName: "", showEquipmentClonePopup: true })}
                                                                />
                                                            }
                                                        />
                                                    }
                                                </div>
                                            </div>
                                        )
                                    }
                                </>
                            }
                        </PerfectScrollbar>
                    </Card.Body>
                    <Modal backdrop="static" show={utils.showEquipmentClonePopup}
                        onHide={() => setUtils({ ...utils, showEquipmentClonePopup: false })} 
                    >
                        <Modal.Header closeButton>
                            <h4 className="font-weight-bold">Clone {utils.selectedEquipment.name}</h4>
                        </Modal.Header>
                        <Modal.Body>
                            <center className="my-5">
                                {
                                    cloneEquipmentQuery.isFetching ?
                                        <ClipLoader className="text-center" color="#075978" />
                                            :
                                        <input
                                            onChange={(e) => setUtils({ ...utils, clonedEquipmentName: e.target.value })}
                                            style={{"border": "none", "borderBottom": "1px solid #075978"}}
                                            className="w-100" placeholder="Please enter an equipment name"
                                            value={utils.clonedEquipmentName}
                                        />
                                }
                            </center>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                disabled={_.isEmpty(utils.clonedEquipmentName)}
                                onClick={() => cloneEquipmentQuery.refetch()}
                            >
                                Submit
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    {
                        utils.showApplyCategoryPopup && 
                            <ApplyOrViewCategoryToMultipleUnits
                                profileId={profileId}
                                isEditOngoing={isEditOngoing}
                                closePopup={() => setUtils({ ...utils, showApplyCategoryPopup: false })}
                            />
                    }
                </Card >
            </Col>
    )
}

export default EquipmentList;